import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import AdminLayout from "../../components/layout/AdminLayout/AdminLayout";
import awardService from "../../services/award/awardService";
import sweetAlert from "../../utils/sweetAlert";
import { toast } from "react-toastify";

import "./Award.css";
export default function AwardList() {

    const [award, setAward] = useState([]);

    const [loading, setLoading] = useState(true);

    const [page, setPage] = useState(1);

    const [pageSize] = useState(10);

    const [search, setSearch] = useState("");

    const [totalPages, setTotalPages] = useState(0);

    useEffect(() => {
        loadAward();
    }, [page, search]);

    const loadAward = async () => {

        try {

            setLoading(true);

            const response = await awardService.getList(
                page,
                pageSize,
                search
            );

            if (response.success) {

                setAward(response.data.items);

                setTotalPages(response.data.totalPages);

            }

        }
        catch (error) {

            console.log(error);

        }
        finally {

            setLoading(false);

        }

    };
    const handleDelete = async (id) => {

        const confirmed = await sweetAlert.confirmDelete();

        if (!confirmed) {

            return;

        }

        try {

            const response = await awardService.delete(id);

            if (response.success) {

                toast.success(response.message);

                loadAward();

            }
            else {

                toast.error(response.message);

            }

        }
        catch (error) {

            console.log(error);

            toast.error("Something went wrong.");

        }

    };
    return (

        <AdminLayout>

            <div className="page-header">

                <h2>Award</h2>

                <Link
                    to="/awards/add"
                    className="btn btn-primary"
                >
                    Add Award
                </Link>

            </div>
            <div className="d-flex mb-3 gap-2">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Search Award..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />

                <button
                    className="btn btn-primary"
                    disabled={loading}
                    onClick={() => setPage(1)}
                >
                    Search
                </button>
            </div>
            <div className="card">

                <div className="card-body">

                    <table className="table table-bordered">


                        <thead>
                            <tr>
                                <th>Image</th>
                                <th>Title</th>
                                <th>Date</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>


                        <tbody>

                            {
                                loading ?

                                    <tr>
                                        <td colSpan="5" className="text-center">
                                            Loading...
                                        </td>
                                    </tr>

                                    :

                                    award.length === 0 ?

                                        <tr>
                                            <td colSpan="4" className="text-center">
                                                No Award Found
                                            </td>
                                        </tr>

                                        :

                                        award.map(item => (

                                            <tr key={item.awardId}>

                                                <td style={{ width: "90px" }}>
                                                    {
                                                        item.awardImage ?

                                                            <img
                                                                src={`${process.env.REACT_APP_SERVER_URL}${item.awardImage}`}
                                                                alt={item.awardTitle}
                                                                className="img-thumbnail"
                                                                style={{
                                                                    width: "70px",
                                                                    height: "70px",
                                                                    objectFit: "cover"
                                                                }}
                                                            />

                                                            :

                                                            "-"
                                                    }
                                                </td>

                                                <td>{item.awardTitle}</td>

                                                <td>
                                                    {
                                                        item.awardDate
                                                            ? new Date(item.awardDate).toLocaleDateString("en-IN")
                                                            : "-"
                                                    }
                                                </td>

                                                <td>
                                                    {
                                                        item.isActive
                                                            ? <span className="badge bg-success">Active</span>
                                                            : <span className="badge bg-danger">Inactive</span>
                                                    }
                                                </td>

                                                <td>

                                                    <Link
                                                        to={`/awards/edit/${item.awardId}`}
                                                        className="btn btn-warning btn-sm me-2"
                                                    >
                                                        Edit
                                                    </Link>

                                                    <button
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => handleDelete(item.awardId)}
                                                    >
                                                        Delete
                                                    </button>

                                                </td>

                                            </tr>

                                        ))
                            }

                        </tbody>

                    </table>

                </div>

            </div>

        </AdminLayout>

    );

}